import React from 'react';
import { Input } from '@chargify/custom-ui-components';

import { renderPrice } from './renderPrice';
import { Allocation, SerializedComponent } from '../../../machines';
import { ComponentPreview } from '../types';

export const createQuantityRow = (
  component: SerializedComponent,
  onUpdateAllocation: (allocation: Allocation) => void,
  locale: string,
  hasError: boolean
): ComponentPreview => ({
  name: component.name,
  description: component.description,
  memo: component.memo,
  renderPrice: () => renderPrice(component.price, locale),
  renderControl: () => (
    <div style={{ maxWidth: 80 }}>
      <Input
        value={component.allocatedQuantity.toString()}
        hasError={hasError}
        onChange={(e) => {
          const {
            target: { value },
          } = e;
          const regex = component?.allowFractionalQuantities
            ? /^\d*(?:\.\d{0,4})?$/
            : /^\d*$/;
          regex.test(value) &&
            onUpdateAllocation({
              id: component.id,
              quantity: value,
              memo: component.memo,
            });
        }}
        disabled={!component.updatesAllowed}
      />
    </div>
  ),
  disableMemo: !component.updatesAllowed,
  ...(component.updatesAllowed && {
    onMemoChange: (e: React.ChangeEvent<HTMLInputElement>) =>
      onUpdateAllocation({
        id: component.id,
        quantity: component.allocatedQuantity,
        memo: e?.target?.value || '',
      }),
  }),
});
